<template>
    <el-dialog
        title="请输入IMEI号"
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <el-form >
          <el-form-item  prop="iemi" >
              <!-- <el-input  v-model="form.imei"  autocomplete="off"></el-input> -->
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入要删除的imei, 多个请用，隔开"
                v-model="Dform.imei">
                </el-input>
        </el-form-item>
            <div class="buttom-box">
                    <el-button type="primary" @click="AddClick()">删除</el-button>
                    <el-button @click="handleClose">返回</el-button>
                </div>
    </el-form>
        
    </el-dialog>
</template>
<script>
import { DeleteDevice} from '@/assets/api/api'
// import { ElMessage } from 'element-plus'

export default {
    components: {
    },
    // props: ['HuanjiObj'],
    data() {

        return {
            dialogVisible: true,
            title:'',
            // deviceIds:[],
            cardid:"",
            schoolList:[],
            Dform:{
                imei:''
            }
          
        }

    },
    created(){
       
    },
    mounted(){
    },
    methods:{
        handleClose() {
                this.$emit('closeClick')
        },
        AddClick(){
            this.deviceClick()
        },
            deviceClick(){
                const params = {
                    imeiStr:this.Dform.imei,
                   
                }
                DeleteDevice(params).then((res)=> {
                    console.log(res,'删除终端');
                    this.$message({
                                type: 'success',
                                message: '终端删除成功'
                            });
                         this.handleClose()
            }).catch((err)=> {
                this.$message({
                        type: 'error',
                        message: err.response.data.msg
                    });
            })
            }
          }
        }




</script>
<style  scoped lang="scss">
    :deep() {

        .el-input--small .el-input__wrapper{
            height: 35px;
            line-height: 35px;
            text-align: center;
            width: 280px;
        }
 
        .el-input__inner{
            // width: 10px !important;
        }
        .buttom-box {
        // text-align: center;
        margin-left: 180px;

    }
    
    .el-form-item--small{
        width: 70% !important;
    }
    }
</style>